import toLower from 'ramda/src/toLower'

const number = 'number'
const nonNegativeNumber = 'nonNegativeNumber'
const registerEmail = 'registerEmail'

const getEventValue = (value, event) => {
	if (typeof value !== 'undefined') {
		return value
	}

	const eventType = event?.currentTarget?.type

	if (eventType === 'number') {
		return event?.currentTarget?.valueAsNumber
	}

	return event?.currentTarget?.value ?? ''
}

export default (
	moduleKey,
	fieldPath,
	action,
	fieldType,
	locked,
	fieldDefaultStaticText,
	valueMod,
	{ propName, customized } = {},
) => async (e) => {
	if (locked) return
	if (e) { e.preventDefault() }
	let value = getEventValue(valueMod, e)
	if (fieldType === number || fieldType === nonNegativeNumber) {
		const re = /\D/
		// eslint-disable-next-line no-unsafe-optional-chaining
		const input = value?.[value?.length - 1]

		if (input !== undefined && input.match(re)) {
			value = value.slice(0, value.length - 1)
		}

		// Convert to number
		if (!Number.isNaN(value)) {
			value = parseInt(value, 10)
		} else {
			value = null
		}

		if (value > 999999) value = 999999
		if (fieldType === nonNegativeNumber) {
			if (value !== null && value < 0) {
				value = 0
			}
		}
	}

	if (fieldType === registerEmail) {
		value = toLower(value)
	}

	if (fieldType === nonNegativeNumber && (typeof value !== 'number' || Number.isNaN(value))) {
		value = null
	}

	action(
		fieldType === 'textWithToggle' && !value[propName]
			? { [propName]: customized, value }
			: value?.length && fieldDefaultStaticText
				? fieldDefaultStaticText + value
				: value,
		moduleKey,
		fieldPath,
	)
}
